module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAL9JREFUWAntmEEKgzAQRU3xMD1F68prVa/lyvYUvc00UjfCKJl8qFBedpn8T5LnDwmmprJdb/2QrY9C+/h+TYs+3C5hx48NLFAFDkEIqgRUPxmEoEpA9ZNBlWDKr5LSF8l2LrOuSanbFnd6ZnPWzjujh+VlgXaoOHmQDKofAIIQVAmofjL49wTbvMOxapffq+5e5DV7Vl91RRM4Iv4srFA4xU46QiUIhnA5Ygg6UEIlCIZwOWIIOlBCJQiGcDniDwfCGaYY14mlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/dark_blue_add.png
// module id = 1215
// module chunks = 0